import { GeoSuggestModel } from '../../data-layer/geo/types';

export const toGeoSuggestsUI = (suggest: GeoSuggestModel) => ({
    id: String(suggest.region_id),
    name: suggest.name,
});
